import React, { Fragment, useState } from "react";
import Logo1 from "../../assets/logo1.svg";
import { CloseCircle, HamburgerMenu } from "iconsax-reactjs";
import { motion, AnimatePresence } from "framer-motion";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      title: "Home",
      link: "#Home",
    },
    {
      title: "About Us",
      link: "#About-Us",
    },
    {
      title: "Products and Services",
      link: "#Products-and-Services",
    },
    {
      title: "Team",
      link: "#Team",
    },
  ];

  // Variants for container (stagger children)
  const containerVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
      opacity: 1,
      height: "100vh",
      transition: {
        duration: 0.4,
        when: "beforeChildren",
        staggerChildren: 0.15, // items appear one by one
      },
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: { duration: 0.3 },
    },
  };

  // Variants for menu items
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    exit: { opacity: 0, y: 20 },
  };

  return (
    <Fragment>
      {/* Header */}
      <header className="flex justify-between items-center fixed top-4 w-[calc(100vw-80px)] lg:w-[calc(100vw-150px)] px-[21px] py-[15px] bg-white shadow-xl rounded-full z-50">
        <img src={Logo1} alt="Logo" />
        <ul className="hidden lg:flex gap-[35px]">
          {menuItems.map((item, i) => (
            <li key={i} className="actor-regular text-lg cursor-pointer">
              <a href={`${item.link}`}>{item.title}</a>
            </li>
          ))}
        </ul>
        <button className="hidden lg:block bg-[#EEB762] rounded-full h-[45px] px-10">
          <a href="#Contact-Us" className="text-white actor-regular text-base">
            Get in Touch
          </a>
        </button>
        <div
          className="flex justify-center items-center lg:hidden cursor-pointer"
          onClick={() => setIsOpen(true)}
        >
          <HamburgerMenu size="32" color="#24215A" />
        </div>
      </header>

      {/* Animated Drawer */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="drawer"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={containerVariants}
            className="fixed top-0 left-0 w-full bg-[#000000D9] flex flex-col items-center justify-center overflow-hidden z-50"
          >
            <ul className="space-y-6 text-center">
              {menuItems.map((item, i) => (
                <motion.li
                  key={i}
                  variants={itemVariants}
                  className="changa-one-regular text-4xl text-white cursor-pointer"
                >
                  <a href={`${item.link}`} onClick={() => setIsOpen(false)}>
                    {" "}
                    {item.title}
                  </a>
                </motion.li>
              ))}
            </ul>
            <motion.div
              className="absolute bottom-10 cursor-pointer"
              onClick={() => setIsOpen(false)}
              variants={itemVariants}
            >
              <CloseCircle size="36" color="#fff" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </Fragment>
  );
}

export default Header;
